import React, { useState } from 'react';
import SEO from '../components/SEO';

const PirtiesNamukas = () => {
  const [formData, setFormData] = useState({
    vardas: '',
    email: '',
    zinute: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Images for the grid
  const row1Images = ['/img/pirtis-1.jpg', '/img/pirtis-2.jpg', '/img/pirtis-3.jpg'];
  const row2Images = ['/img/pirtis-4.jpg', '/img/pirtis-5.jpg', '/img/pirtis-6.jpg', '/img/pirtis-7.jpg'];

  return (
    <div>
      <SEO 
        title="Pirties Namukas"
        description="Pirties namukas Sporto Krante - autentiška lietuviška pirtis, SPA malonumai, poilsis gamtoje. Idealus pasirinkimas atsipalaidavimui."
        keywords="pirtis, pirties namukas, SPA, sauna, poilsis, atsipalaidavimas, sporto krantas"
        canonicalUrl="https://sportokrantas.lt/pirties-namukas"
      />
      {/* First Section - White background */}
      <section className="py-12 border-b-[3px] border-black bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-black mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
            PIRTIES NAMUKO NUOMA - POILSIS, KURIS SUGRĄŽINA BALANSĄ
          </h1>
          <div className="space-y-2 text-black leading-relaxed mb-2">
            <p>
              Ieškote jaukios vietos poilsiui gamtoje, ramybės savaitgaliui ar prasmingam laikui su artimaisiais? Mūsų Privatus ežero namelis su pirtimi – tai daugiau nei pirtis. Tai vieta, kur sustoja laikas, o kūnas ir mintys atsigauna.
            </p>
            <p>
              Pirties namukas pritaikytas tiek ramiam poilsiui, tiek jaukiam pasibuvimui su šeima ar draugais. Autentiška lietuviška pirtis, šiluma ir natūrali aplinka leidžia visiškai atsipalaiduoti ir pasimėgauti tikru poilsiu be skubėjimo.
            </p>
            <p>Jūsų patogumui:</p>
          </div>
          <ul className="list-disc pl-8 space-y-1 text-black mb-2">
            <li>erdvi ir jauki pirties zona</li>
            <li>poilsio erdvė atsikvėpti po kaitros</li>
            <li>lauko terasa ramiems vakarams</li>
            <li>privati aplinka gamtos apsuptyje</li>
          </ul>
          <div className="space-y-2 text-black leading-relaxed mb-2">
            <p>Pirties namukas puikiai tinka:</p>
          </div>
          <ul className="list-disc pl-8 space-y-1 text-black mb-2">
            <li>ramiam savaitgalio poilsiui</li>
            <li>mažoms šventėms ir pasibuvimams</li>
            <li>atokvėpiui po aktyvios dienos ar sporto veiklų</li>
          </ul>
          <div className="space-y-2 text-black leading-relaxed mb-8">
            <p>
              Leiskite sau lėtą, kokybišką poilsį – tokį, kuris įkvepia, atpalaiduoja ir palieka gerą jausmą dar ilgai po viešnagės.
            </p>
          </div>

          {/* 11 images grid - Row 1: 3 images, Row 2: 4 images, Row 3: 4 images */}
          <div className="space-y-2">
            {/* Row 1 - 3 larger landscape images */}
            <div className="grid grid-cols-3 gap-2">
              {row1Images.map((src, index) => (
                <div key={`row1-${index}`} className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={src} 
                    alt={`Pirties namukas ${index + 1}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              ))}
            </div>
            {/* Row 2 - 4 smaller square images */}
            <div className="grid grid-cols-4 gap-2">
              {row2Images.map((src, index) => (
                <div key={`row2-${index}`} className="aspect-square overflow-hidden">
                  <img 
                    src={src} 
                    alt={`Pirties namukas ${index + 4}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Second Section - Dark background, text left 60%, image right 40% */}
      <section className="border-b-[3px] border-black" style={{ backgroundColor: '#111315' }}>
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Content - 60% */}
          <div className="lg:col-span-6 px-8 py-12 lg:py-16 lg:px-12 flex flex-col justify-center">
            <h2 className="text-white mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
              Sporto kranto teritorija - poilsiui, judesiui ir buvimui kartu
            </h2>
            <div className="space-y-2 text-white leading-relaxed text-justify">
              <p>
                „Sporto kranto" teritorija sukurta taip, kad kiekvienas čia rastų savo tempą – tiek aktyviam judesiui, tiek ramiam poilsiui po darbų ar susitikimų. Erdvi, prižiūrėta ir gamtos apsupta aplinka leidžia lengvai atsitraukti nuo kasdienės rutinos ir būti gryname ore.
              </p>
              <p>
                Teritorijoje įkurti modernūs teniso kortai, tinkantys tiek aktyviam laisvalaikui, tiek draugiškoms komandinėms varžyboms. Tai puiki galimybė išjudinti kūną, iškrauti mintis ir natūraliai įnešti energijos į darbostogų dieną.
              </p>
              <p>
                Prie pat ežero įrengta prieplauka su galimybe išsimaudyti ežere. Vasaros metu tai tampa viena mėgstamiausių vietų – rytiniam atsigaivinimui, ramiam poilsiui ar vakariniam atsipalaidavimui po pirties.
              </p>
              <p>
                Šiltuoju sezonu galima grilinti lauke, organizuoti jaukius bendrus vakarus ar neformalius komandos susibūrimus gamtoje. Norintiems daugiau sąmoningo judesio, siūlome galimybę užsisakyti jogos, balanso ar kitas lengvas treniruotes, kurios padeda atstatyti kūno balansą po darbo dienos.
              </p>
            </div>
          </div>

          {/* Image - 40% */}
          <div className="lg:col-span-4 min-h-[400px] overflow-hidden">
            <img 
              src="/img/pirtis-8.jpg" 
              alt="Sporto kranto teritorija" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Third Section - Background image with contact form */}
      <section className="relative border-b-[3px] border-black">
        {/* Background image */}
        <div className="absolute inset-0">
          <img 
            src="/img/pirtis-7.jpg" 
            alt="Fonas" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        </div>

        {/* Content overlay */}
        <div className="relative z-10 py-16 lg:py-24 flex items-center justify-center">
          <div className="bg-white p-8 lg:p-10 w-full max-w-md mx-4">
            <h3 className="text-black mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '20px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
              PARAŠYKITE MUMS
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <input
                  type="text"
                  name="vardas"
                  placeholder="Vardas *"
                  value={formData.vardas}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-500 text-sm"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="El. paštas *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-500 text-sm"
                />
              </div>
              <div>
                <textarea
                  name="zinute"
                  placeholder="Žinutė *"
                  value={formData.zinute}
                  onChange={handleChange}
                  required
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-500 text-sm resize-none"
                />
              </div>
              <button
                type="submit"
                className="w-full py-3 font-medium text-black transition-colors hover:opacity-90"
                style={{ backgroundColor: '#D0AB64' }}
              >
                Siųsti
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PirtiesNamukas;
